// extracted by mini-css-extract-plugin
module.exports = {"heading":"StoryHero_heading__DP4l_","title":"StoryHero_title__x_Ccs","preTitle":"StoryHero_preTitle__pta8d","scribble":"StoryHero_scribble__oxS9Q"};